// TODO: auto-generate it from routes

type UrlOptions = {
  host?: boolean;
};

export function getUrlOrigin(): string {
  if (process.env.NEXT_PUBLIC_WEB_CLIENT_HOST) {
    return process.env.NEXT_PUBLIC_WEB_CLIENT_HOST;
  }

  if (typeof window === "undefined") {
    return "https://corca.app";
  }

  return window.location.origin;
}

function getUrl(url: string, options: UrlOptions = {}) {
  const { host } = options;
  if (typeof window !== "undefined" && host) {
    return `${window.location.protocol}//${window.location.host}${url}`;
  }
  return url;
}

export function docPageUrl(
  {
    docId,
    teamPermalink,
    preview,
    chat,
    message,
  }: {
    docId: string;
    teamPermalink?: string;
    preview?: boolean;
    chat?: string;
    message?: string;
  },
  options?: UrlOptions,
): string {
  // Ensure teamPermalink is not empty to avoid double slashes
  const safeTeamPermalink = teamPermalink || "doc";
  const params = new URLSearchParams();
  if (preview) params.set("preview", "true");
  if (chat) params.set("chat", chat);
  if (message) params.set("message", message);
  const query = params.toString();
  return getUrl(`/${safeTeamPermalink}/${docId}${query ? `?${query}` : ""}`, options);
}

export function folderPageUrl({ folderId }: { folderId: string }, options?: UrlOptions): string {
  return getUrl(`/folder/${folderId}`, options);
}

export function chatPageUrl(
  { chatId, message }: { chatId: string; message?: string },
  options?: UrlOptions,
): string {
  return getUrl(
    `/chat/${chatId}${message ? `?message=${encodeURIComponent(message)}` : ""}`,
    options,
  );
}

export function teamPageUrl(
  {
    teamPermalink,
    preview,
    signup,
  }: { teamPermalink: string; preview?: boolean; signup?: boolean },
  options?: UrlOptions,
): string {
  // Ensure teamPermalink is not empty to avoid double slashes
  const safeTeamPermalink = teamPermalink || "doc";
  const params = new URLSearchParams();
  if (preview) params.set("preview", "true");
  if (signup) params.set("signup", "true");
  const query = params.toString();
  return getUrl(`/${safeTeamPermalink}${query ? `?${query}` : ""}`, options);
}
